import { Card, CheckboxCard } from "@/src/components/cards";
import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import { FrequentSnomedParent, SnomedConcept } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";
import SnomedCategoryName from "./snomedCategoryName";
import SnomedSynonymHighliter from "./snomedSynonymHighlighter";

export default function SnomedConceptCheckbox({
  filteredParentIds,
  isActive,
  concept,
  searchKey,
  onClick,
}: {
  filteredParentIds?: FrequentSnomedParent[];
  isActive: boolean;
  concept: SnomedConcept;
  searchKey: string;
  onClick?: () => void;
}) {
  const [isLoading, setIsLoading] = useState(false);
  if (concept == null || typeof concept != "object") return null;
  return (
    <CheckboxCard
      color="simple"
      title={
        <div className="capitalize">
          <SearchKeyHighliter searchKey={searchKey}>
            {concept.name || ""}
          </SearchKeyHighliter>
        </div>
      }
      status={isActive ? "active" : "inactive"}
      className={`${isLoading ? "disabled" : ""}`}
      onClick={async () => {
        if (!concept.id) return;
        setIsLoading(true);
        apiFetch("snomedConcepts", "incrementCount", {
          conceptId: concept.id,
        });
        await onClick?.();
        setIsLoading(false);
      }}
      // leading={
      //   <div
      //     style={{ cursor: "pointer", padding: "5px 0px" }}
      //     data-tooltip-id={`snomedTooltip${concept.id}`}
      //     data-tooltip-variant="info"
      //     onClick={async (e) => {
      //       e.stopPropagation();
      //       if (!concept.id) return;
      //       const fullConcept = await apiFetch(
      //         "snomedConcepts",
      //         "loadFullConcept",
      //         {
      //           conceptId: concept.id,
      //         }
      //       );

      //       if (!fullConcept) throw new Error("Concept not found");
      //       await openDialog({
      //         id: `snomedDialog${fullConcept.id}`,
      //         title: fullConcept.name || "",
      //         content: (
      //           <div className="c1 gap10">
      //             <div className="bold">Parents</div>
      //             {fullConcept.allParents
      //               ?.filter((parent) => parent?.name)
      //               .map((parent) => (
      //                 <div key={uid()}>{parent.name}</div>
      //               ))}
      //           </div>
      //         ),
      //       });
      //     }}
      //   >
      //     <Tooltip
      //       id={`snomedTooltip${concept.id}`}
      //       place="bottom"
      //       variant="info"
      //       content={`
      //           Synonymes \n
      //           ${concept.synonyms?.split(" , ").join("\n ")}
      //         `}
      //       style={{
      //         zIndex: 9999999999,
      //         maxWidth: "500px",
      //         background: "white",
      //         opacity: "1",
      //         color: "black",
      //         fontSize: "14px",
      //         boxShadow: "2px 2px 10px RGBA(0,0,0,0.2)",
      //         padding: "15px",
      //         borderRadius: "10px",
      //       }}
      //     />
      //     <MdOutlineInfo size={18} />
      //   </div>
      // }
      trailing={<span className="gray">{concept.count}</span>}
    >
      <div className="c1 gap5">
        <SnomedSynonymHighliter
          searchKey={searchKey}
          name={concept.name || ""}
          synonyms={concept.synonyms || ""}
        />
        <SnomedCategoryName
          concept={concept}
          filteredParentIds={filteredParentIds}
        />
  
      </div>
    </CheckboxCard>
  );
}
